import { Box, Link, useForegroundVariantColor } from "@seneca/senekit";

import { useMakeLinkToRelatedExamQuestions } from "features/assignments/common/hooks/useMakeLinkToRelatedExamQuestions";
import { ExamQuestionsSource } from "features/exam-questions/analytics";

type Props = {
  examQuestionsInAssignmentSections: string[];
  courseId: string;
};

export default function RelatedExamQuestionsLink(props: Props) {
  const { examQuestionsInAssignmentSections, courseId } = props;

  const foregroundVariantColor = useForegroundVariantColor("3");

  const linkToRelatedExamQuestions = useMakeLinkToRelatedExamQuestions({
    examQuestionsInAssignmentSections,
    courseId,
    source: ExamQuestionsSource.assignmentSidebar
  });

  return (
    <Box paddingTop="large" paddingX="large">
      <Box
        padding="xlarge"
        backgroundColor={foregroundVariantColor}
        borderRadius="large"
      >
        <Link to={linkToRelatedExamQuestions} size="small">
          Try related Exam Questions
        </Link>
      </Box>
    </Box>
  );
}
